import { render, staticRenderFns } from "./SkeletonApplicant.vue?vue&type=template&id=86c52cc2&scoped=true&"
import script from "./SkeletonApplicant.vue?vue&type=script&lang=js&"
export * from "./SkeletonApplicant.vue?vue&type=script&lang=js&"
import style0 from "./SkeletonApplicant.vue?vue&type=style&index=0&id=86c52cc2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86c52cc2",
  null
  
)

component.options.__file = "SkeletonApplicant.vue"
export default component.exports